import { useLayoutEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import { IconButton, Input } from "@mui/material"
import { Check, FileCopy } from "@mui/icons-material"
import classNames from "classnames"
import { copyToClipboard } from "helpers/clipboard"
import "./style.scss"

function CopyableTextField({ id, label, value, useValueChangeEffect }) {
  const [valueCopied, setValueCopied] = useState(false)
  const [updated, setUpdated] = useState(false)
  const initialLoad = useRef(true)

  const handleCopyValue = () => {
    setValueCopied(true)
    copyToClipboard(value, () => setValueCopied(false))
  }

  useLayoutEffect(() => {
    if (initialLoad.current) {
      initialLoad.current = false
      return
    }
    if (useValueChangeEffect && value) {
      setUpdated(true)
      setTimeout(() => setUpdated(false), 500)
    }
  }, [value, useValueChangeEffect])

  return <div className="components_copyable-text-field">
    {!!label && <div className="label">{label}</div>}
    <Input
      className={classNames("value", { updated })}
      disabled
      type="text"
      id={id}
      value={value}
    />
    <div className="copy-button">
      <IconButton className={classNames({ success: valueCopied })} disabled={valueCopied} size="medium" color="primary" onClick={() => handleCopyValue()}>
        {!valueCopied ? <FileCopy /> : <Check />}
      </IconButton>
    </div>
  </div>
}

CopyableTextField.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  useValueChangeEffect: PropTypes.bool,
}

export default CopyableTextField
